module.exports = __webpack_public_path__ + "img/2_x6.f884200c.png";